module.exports = __webpack_public_path__ + "img/four1Red.1c135b2a.jpg";